import React from "react";
import { Link } from "react-router-dom";
import { AffiliateSettingInterface, ApiHelper, UserHelper } from "../../helpers";


interface Props {

}


export const SettingsSidebar: React.FC<Props> = props => {

  const [affiliateSetting, setAffiliateSetting] = React.useState<AffiliateSettingInterface>(null);
  const init = () => {
    ApiHelper.get("/affiliateSettings").then((data) => {
      if (data.length > 0) setAffiliateSetting(data[0]);
    });
  }
  React.useEffect(init, [])



  let activeSection = "";
  if (window.location.href.indexOf("/support") > -1) activeSection = "support";
  else if (window.location.href.indexOf("/feeds") > -1) activeSection = "feeds";
  else if (window.location.href.indexOf("/settings/billing") > -1) activeSection = "billing";
  else if (window.location.href.indexOf("/settings/feedAdmin") > -1) activeSection = "feedAdmin";
  else if (window.location.href.indexOf("/settings/templates") > -1) activeSection = "templates";
  else if (window.location.href.indexOf("/settings/affiliate") > -1) activeSection = "affiliate";
  else if (window.location.href.indexOf("/settings/admin") > -1) activeSection = "admin";
  else if (window.location.href.indexOf("/setttings") > -1) activeSection = "settings";

  const getLinkClass = (sectionName: string) => {
    if (sectionName === activeSection) return "active"; else return "";
  }


  const getBilling = () => {

    if (UserHelper.checkAccess("owner") || UserHelper.checkAccess("admin")) return <>
      <li className="nav-item"><Link className={getLinkClass("feeds")} to={"/settings/feeds"}><i className="fas fa-satellite-dish"></i> Feeds</Link></li>
      <li className="nav-item"><Link className={getLinkClass("billing")} to={"/settings/billing"}><i className="fas fa-credit-card"></i> Billing</Link></li>
    </>
  }


  const getAdmin = () => {
    if (UserHelper.checkAccess("admin")) {
      return <>
        <hr />
        <ul className="nav flex-column">
          <li className="nav-item"><Link className={getLinkClass("templates")} to={"/settings/templates"}><i className="fas fa-code"></i> Templates</Link></li>
          <li className="nav-item"><Link className={getLinkClass("admin")} to={"/settings/admin"}><i className="fas fa-lock"></i> Admin</Link></li>
        </ul>
      </>
    }
  }

  const getCreator = () => {

    const result: React.ReactElement[] = [];
    if (affiliateSetting) result.push(<li key="affiliate" className="nav-item"><Link className={getLinkClass("affiliate")} to={"/settings/affiliate"}><i className="fas fa-money-bill-wave"></i> Affiliate</Link></li>)
    if (UserHelper.checkAccess("creator") || UserHelper.checkAccess("admin")) result.push(<li key="feedAdmin" className="nav-item"><Link className={getLinkClass("feedAdmin")} to={"/settings/feedAdmin"}><i className="fas fa-satellite-dish"></i> Feed Admin</Link></li>);
    if (result.length > 0) {
      return <>
        <hr />
        <ul className="nav flex-column">
          {result}
        </ul>
      </>
    }
  }


  return (
    <>
      <div className="titlebar">
        <div className="title"><i className="fas fa-cog"></i> SETTINGS</div>
      </div>
      <ul className="nav flex-column">
        <li className="nav-item"><Link className={getLinkClass("settings")} to={"/settings"}><i className="fas fa-cog"></i> Settings</Link></li>
        <li className="nav-item"><Link className={getLinkClass("support")} to={"/settings/support"}><i className="fas fa-comments"></i> Support</Link></li>
        {getBilling()}
      </ul>
      {getCreator()}
      {getAdmin()}
    </>
  );
};